import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Col, Form, Row } from "react-bootstrap";
import locationData from "../../countries.json";
import CustomSelect from "../CustomSelect";

const Domicile = ({ formik }) => {
  const { t } = useTranslation();
  const [countries, setCountries] = useState([]);

  const handleSameAsDomicile = (e) => {
    const { checked } = e.target;
    if (checked) {
      formik.setValues({
        ...formik.values,
        addressHome: formik.values.address,
        provinceHome: formik.values.province,
        cityHome: formik.values.city,
        postcodeHome: formik.values.postcode,
      });
    } else {
      formik.setValues({
        ...formik.values,
        addressHome: "",
        provinceHome: "",
        cityHome: "",
        postcodeHome: "",
      });
    }
  };

  useEffect(() => {
    const data = locationData.map((country) => ({
      value: country.name,
      label: country.name,
    }));
    setCountries(data);
  }, []);

  return (
    <>
      <Row>
        <Form.Group xs={12} className="mb-3">
          <Form.Check
            type="switch"
            label={t("sameAsDomicile")}
            className="mb-3"
            onChange={(e) => handleSameAsDomicile(e)}
          />
        </Form.Group>
        <Form.Group as={Col} xs={12} md={6} className="mb-3">
          <Form.Label>{t("form.address")} *</Form.Label>
          <Form.Control
            type="text"
            name="addressHome"
            placeholder={t("form.address")}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.addressHome}
            isInvalid={
              formik.touched.addressHome && !!formik.errors.addressHome
            }
          />
          <Form.Control.Feedback type="invalid">
            {t(`error.${formik.errors.addressHome}`)}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} xs={12} md={6} className="mb-3">
          <Form.Label>{t("form.country")} *</Form.Label>
          <CustomSelect
            formik={formik}
            name="provinceHome"
            options={countries}
            placeholder={t("form.select")}
          />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} xs={12} md={6} className="mb-3">
          <Form.Label>{t("form.city")} *</Form.Label>
          <Form.Control
            type="text"
            name="cityHome"
            placeholder={t("form.city")}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.cityHome}
            isInvalid={formik.touched.cityHome && !!formik.errors.cityHome}
          />
          <Form.Control.Feedback type="invalid">
            {t(`error.${formik.errors.cityHome}`)}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} xs={12} md={6} className="mb-3">
          <Form.Label>{t("form.postcode")} *</Form.Label>
          <Form.Control
            type="text"
            name="postcodeHome"
            placeholder={t("form.postcode")}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.postcodeHome}
            isInvalid={
              formik.touched.postcodeHome && !!formik.errors.postcodeHome
            }
          />
          <Form.Control.Feedback type="invalid">
            {t(`error.${formik.errors.postcodeHome}`)}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>
    </>
  );
};

export default Domicile;